import axios from "axios"
import Cookies from "js-cookie"
import { ACC_TKN, DOMAIN, RFSH_TKN } from "./Constant"
import { isEmpty } from "./Helper"
import routes from "../Routes/MainRoutes"
import { addMilliseconds } from "date-fns"

const BASE_URL = "https://api.v2.mbg.cekgudang.com/"

const handleExpireTkn = () => routes.navigate('/login', { replace: true })
const callRefreshToken = async () => {
	const refreshTkn = Cookies.get(RFSH_TKN)
	if (isEmpty(refreshTkn)) return handleExpireTkn()

	const postData = new FormData()
	postData.append("refresh_token", refreshTkn)
	const { code, data } = await axios
		.create({ baseURL: BASE_URL, responseType: "json" })
		.post("auth/refreshtoken", postData)
		.then((res) => res.data)
	if (code !== 200) throw new Error('Token refresh failed or expired');
	const expires = addMilliseconds(new Date(), (data?.expires_in ?? 10) * 1000)
	Cookies.set(ACC_TKN, data?.access_token, { expires });
	Cookies.set(RFSH_TKN, data?.refresh_token, { expires });
	return data?.access_token;
}

const AuthInInterceptor = (axiosObj = axios.create()) => {
	let isRefreshing = false;
	let failedQueue = [];

	axiosObj.interceptors.request.use(
		(req) => {
			const token = Cookies.get(ACC_TKN);
			if (isEmpty(token)) return handleExpireTkn()
			if (!isEmpty(token)) req.headers.Authorization = `Bearer ${token}`
			return req
		},
		(err) => Promise.reject(err)
	)

	axiosObj.interceptors.response.use(
		(res) => res,
		async (err) => {
			const oriReq = err.config
			const status = err?.response?.status

			if ([401].includes(status) && !oriReq._retry) {
				oriReq._retry = true

				if (!isRefreshing) {
					isRefreshing = true;
					try {
						const newToken = await callRefreshToken();

						failedQueue.forEach((callback) => callback(newToken));
						failedQueue = [];

						oriReq.headers.Authorization = `Bearer ${newToken}`;
						return axiosObj(oriReq);
					} catch (refreshError) {
						return Promise.reject(refreshError);
					} finally {
						isRefreshing = false;
					}
				} else {
					return new Promise((resolve, reject) => {
						failedQueue.push((newToken) => {
							oriReq.headers.Authorization = `Bearer ${newToken}`;
							resolve(axiosObj(oriReq));
						});
					});
				}
			}
			return Promise.reject(err?.response ?? err?.data)
		}
	)

	return axiosObj
}

const baseAPI = (baseURL = BASE_URL) => axios.create({ baseURL: baseURL, responseType: "json" })
export const API = baseAPI()
export const APIAuth = AuthInInterceptor(baseAPI())
export const APIFile = axios.create({
	baseURL: BASE_URL,
	headers: { "Content-Type": "multipart/form-data" },
	responseType: "json",
})
